import { ICompleteCheckoutState } from '@modules/checkout-store/reducers/complete-checkout';
import { createSelector } from '@ngrx/store';
import { LoadingDetails, LoadState } from '@nx-ng/types';
import { getCheckoutFeatureState, ICheckoutFeatureState } from '../../reducers';

export const selectCompleteCheckoutState = createSelector(
  getCheckoutFeatureState,
  (state: ICheckoutFeatureState) => state?.completeCheckout
);

export const selectCheckoutInProgress = createSelector(
  selectCompleteCheckoutState,
  (state: ICompleteCheckoutState): LoadingDetails => {
    return {
      isLoading: state.loaded === LoadState.LOADING,
      text: 'checkout_in_progress',
    };
  }
);
